module.exports = __webpack_public_path__ + "7d1e6cb289304346181acf8382b9be85.svg";